var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    style: {
      verticalAlign: "middle"
    },
    viewBox: "0 0 15 13.5",
    preserveAspectRatio: "xMidYMid meet",
    "aria-labelledby": "title"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "11.85 6.35 11.15 5.65 8 8.79 8 0 7 0 7 8.79 3.85 5.65 3.15 6.35 7.5 10.71 11.85 6.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14,9v3.39a.11.11,0,0,1-.11.11H1.11A.11.11,0,0,1,1,12.39V9H0v3.39A1.11,1.11,0,0,0,1.11,13.5H13.89A1.11,1.11,0,0,0,15,12.39V9Z"
  })))));
};
export { SvgDownload as ReactComponent };